import { isAxiosError } from "axios";

export type ExplorerMessagingErrorBody = {
  message?: string;
  code?: string;
  used?: number;
  limit?: number;
  remaining?: number;
  weekResetsUtc?: string;
};

export function isExplorerMessagingNotConnectedError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const status = error.response?.status;
  const data = error.response?.data as ExplorerMessagingErrorBody | undefined;
  return status === 403 || data?.code === "explorer_messaging_not_connected";
}

export function isExplorerMessagingWeeklyLimitError(error: unknown): boolean {
  if (!isAxiosError(error)) return false;
  const status = error.response?.status;
  const data = error.response?.data as ExplorerMessagingErrorBody | undefined;
  return status === 429 || data?.code === "explorer_messaging_weekly_limit";
}

export function getExplorerMessagingLimitErrorBody(
  error: unknown
): ExplorerMessagingErrorBody | undefined {
  if (!isAxiosError(error)) return undefined;
  return error.response?.data as ExplorerMessagingErrorBody | undefined;
}

export const CONNECTION_REMOVED_EVENT = "smbf-connection-removed";

export function dispatchConnectionRemoved(userId: number) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(CONNECTION_REMOVED_EVENT, { detail: { userId } })
  );
}
